import { __rest } from "tslib";
import React, { useState, useMemo } from 'react';
import { Field } from '@klarna/bubble-ui';
const MASK = '**********';
const isEncryptedString = (o) => typeof o === 'object' &&
    (typeof o.encrypted === 'undefined' || typeof o.encrypted === 'string') &&
    (typeof o.clear_text === 'undefined' || typeof o.clear_text === 'string');
export const EncryptedInput = (_a) => {
    var { onBlur = () => { }, onChange = () => { }, onFocus = () => { }, value } = _a, inputProps = __rest(_a, ["onBlur", "onChange", "onFocus", "value"]);
    const [editing, setEditing] = useState(false);
    const [innerValue, setInnerValue] = useState(isEncryptedString(value) ? MASK : '');
    const _onChange = (clearValue) => {
        setInnerValue(clearValue);
        onChange(clearValue.length ? { clear_text: clearValue } : {});
    };
    const _onFocus = event => {
        setEditing(true);
        setInnerValue('');
        onFocus(event);
    };
    const _onBlur = event => {
        setEditing(false);
        _onChange(innerValue);
        onBlur(event);
    };
    const visibleValue = useMemo(() => (innerValue.length ? (editing ? innerValue : MASK) : ''), [
        editing,
        innerValue,
    ]);
    return (React.createElement(Field, Object.assign({}, inputProps, { value: visibleValue, onChange: _onChange, onFocus: _onFocus, onBlur: _onBlur, isUnderlined: true })));
};
EncryptedInput.propTypes = Object.assign({}, Field.propTypes);
